// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__TwO_q","meta":"Pagination_meta__6C4cR","nav":"Pagination_nav__B_uOt","button":"Pagination_button__7JMDL","divider":"Pagination_divider__HWWTp"};